module.exports = __webpack_public_path__ + "img/new_investment.daeebe45.svg";